import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import NorwegianFlag from '../no.png';
import BritishFlag from '../gb.png';

let self;

class LanguageSelectionDialog extends React.Component {
    constructor(props) {
        super(props);
        self = this;
    }

    handleClose = () => {
        this.props.onClose(this.props.selectedValue);
    };

    handleListItemClick = value => {
        this.props.onClose(value);
        this.props.setAndDownloadLanguage(value);
    };

    render() {
        return (
            <Dialog open={this.props.open} onClose={this.handleClose} aria-labelledby="simple-dialog-title">
                <DialogTitle id="simple-dialog-title">{self.props.language === 'nb-NO' ? 'Velg språk' : 'Select language'}</DialogTitle>
                <div>
                    <List style={dialogStyle}>
                        <ListItem button onClick={() => this.handleListItemClick('nb-NO')}>
                            <img src={NorwegianFlag} alt="" width="30" height="20" />
                            <ListItemText primary="Norsk" />
                        </ListItem>
                        <ListItem button onClick={() => this.handleListItemClick('en-US')}>
                            <img src={BritishFlag} alt="" width="30" height="20" />
                            <ListItemText primary="English" />
                        </ListItem>
                    </List>
                </div>
            </Dialog>
        );
    }
}

const dialogStyle = {
    minWidth: "200px"
};

export default LanguageSelectionDialog;


// WEBPACK FOOTER //
// ./src/Components/LanguageSelectionDialog.js